<style lang="scss" scoped>
    .module-section {
        font-size: 18px;

        .section-name {
            color: #4d8ab7;
            font-weight: 300;
            font-size: 1.1em;
        }

        .section-contact-hours {
            color: #223264;
            font-size: 1.0em;
        }

        .handout-link {
            font-size: 1.0em;
        }
    }

    .modal-training-title {
        font-size: 2.0em;
        color: #fff;
    }

    .training-hr {
        margin-top: 5px;
        margin-bottom: 0.8em !important;
    }

    .font-size-3em {
        font-size: 3.0em;
    }

    .yanone {
        font-family: "Yanone Kaffeesatz", sans-serif;
    }

    .completed-training-hover-bg:hover {
        background-color: #ffe3e0;
    }
    
    .completed-training-clickable {
        cursor: pointer;
    }

    .completed-training-instructions {
        color: #4d8ab7 !important;
    }
</style>

<template>
    <div>
        <section id="" class="mb-5">
            <h2 class="lighter text-primary">Get Ready to Learn More</h2>
            <how-to-row>
                <template #left>
                    <print-dropdown icon="icon-book">
                        <template #trigger-label>
                                View the How-To Guide
                        </template>
                        <template #collapse-content>
                            <ul class="list-unstyled">
                                <li class="link-alternate"><a :href="$basePath+'/uploads/GNS_Provider_How_To_Guide_Trainings.pdf'" target="_blank">English Desktop</a></li>
                                <li class="link-alternate"><a :href="$basePath+'/uploads/GNS_Provider_How_To_Guide_Trainings_Spanish.pdf'" target="_blank">Español Desktop</a></li>
                                <li class="link-alternate"><a :href="$basePath+'/uploads/GNS_Provider_How_To_Guide_Trainings_Mobile.pdf'" target="_blank">English Mobile</a></li>
                                <li class="link-alternate"><a :href="$basePath+'/uploads/GNS_Provider_How_To_Guide_Trainings_Mobile Spanish.pdf'" target="_blank">Español Mobile</a></li>
                            </ul>
                        </template>
                    </print-dropdown>
                </template>
            </how-to-row>
        </section>

        <dashboard-tabs :modules="modules" :active-index=0>
            <template #primary="{ module }">
                <div v-if="!isModuleActive(module.slug)" class="font-weight-bold container text-center h-100">
                    <p class="">Coming Soon!</p>
                    <p class="">We are currently working on this module and will launch soon.</p>
                </div>
                <div v-else-if="hasRole('ta-consultant')" class="font-weight-bold container text-center h-100 pt-3">
                    <p>Please click on the name of a training session below to view and  print each participant's Certificate of Training Completion.</p>
                </div>
                <div v-else class='text-center font-weight-bold pt-3'>
                    <p>Click <span class='text-orange'>Start</span> by any section image to start training session. After naming your session, click <span class='text-orange'>Start</span> again to access your training session video, quiz, and evaluation.</p>
                    <p>To receive a <strong>Certificate of Training Completion</strong>: view the full training, pass the knowledge quiz, and complete the training evaluation. Groups viewing the training together will complete one quiz and one evaluation but have the option to print individual certificates.</p>
                </div>
            </template>
            
            <template #secondary="{ module }">
                <div v-if="isModuleActive(module.slug)">
                    <div v-if="!hasRole('ta-consultant')" class="container mx-0 p-4 border-top-0" :class="`border-${module.color}`">
                        <div class="row row-cols-2" v-if="!isLoadingData">
                            <div v-for="training in trainingsInModule(module.id)" :key="training.id" class="col module-section pb-5">
                                <div class="row">
                                    <div class="col col-4">
                                        <div class="section-image img-wrapper-orange">
                                            <img :src="$basePath + '/images/summary/' + training.image_thumb" class="w-100" />
                                        </div>
                                    </div>
                                    <div class="col col-8">
                                        <div class="section-name yanone">{{training.title}}</div>
                                        <hr class="training-hr" />
                                        <div class="section-contact-hours">{{ training.contact_hours }} Contact Hours</div>
                                        <a :href="'uploads/trainings/handouts/' + module.slug + '/' + training.handout_file" class="handout-link text-orange font-weight-bold" target="_blank">Print Handout</a>
                                        <training-start-menu
                                            class="start-menu"
                                            :training-id="training.id"
                                        ></training-start-menu>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-else>
                            <div class="col">
                                <module-loading-icon :color="module.color"></module-loading-icon>
                            </div>
                        </div>
                    </div>

                    <!-- ------------------------------ -->
                    <!-- COMPLETED TRAININGS SECTION -->
                    <!-- ------------------------------ -->
                    <div :class="'completed-trainings row container mx-0 p-4 border-'+ module.color +' border-top-0'"
                    >
                        <div class="col-12">
                            <h2 class="landing mb-4">Completed Training Sessions</h2>
                            <h3 class='completed-training-instructions'>Click on session name to print your Certificate of Training Completion.</h3>

                            <div class="icon-name-view row mx-0 py-3 px-3">
                                <div class="col-sm-4 p-0 text-sm-center align-middle"><span class="module-status-link">Training</span></div>
                                <div class="col-sm-3 p-0 text-sm-left align-middle"><span class="module-status-link">Session</span></div>
                                <div class="col-sm-1 p-0 text-sm-left align-middle"><span class="module-status-link">Total Participants</span></div>
                                <div class="col-sm-2 p-0 text-sm-right align-middle"><span class="module-status-link">Date Started</span></div>
                                <div class="col-sm-2 p-0 text-sm-right align-middle"><span class="module-status-link">Date Completed</span></div>
                            </div>
                            <!-- LOOP THROUGH COMPLETED SESSIONS -->
                            <template v-for="(session, sIdx) in completedSessionsInModule(module)" :key="session.id">
                                <div class="icon-name-view completed-training row mx-0 py-3 px-3" 
                                    :class="{ 
                                        ...completedSessionClasses(sIdx), 
                                        'completed-training-clickable': sessionIsClickable(session),
                                        'completed-training-hover-bg': sessionIsClickable(session),
                                    }" 
                                    v-bind="getModalAttributes(session)" 
                                    @click="onClickCompletedSession(session.training_id, session.id)"
                                >
                                    <div class="col-sm-4 p-0 text-sm-left align-middle">
                                        <div class="row">
                                            <div class="col-2">
                                                <module-icon :module-slug="module.slug" size="md" class="module-icon"></module-icon>
                                            </div>
                                            <div class="col-10">
                                                <div class="module-name">{{ session.training.title }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-3 p-0 text-sm-left align-middle">
                                        <span class="module-status-link" v-html="truncateTitle(session.title, 20)"></span>
                                    </div>
                                    <div class="col-sm-1 p-0 text-sm-left align-middle">
                                        <span class="module-status-link">{{ sessionParticipants[session.id].length || session.participant_count }}</span>
                                    </div>
                                    <div class="col-sm-2 p-0 text-sm-right align-middle">
                                        <span class="module-status-link">{{ formatDate(session.start_time) }}</span>
                                    </div>
                                    <div class="col-sm-2 p-0 text-sm-right align-middle">
                                        <span class="module-status-link">{{ formatDate(session.finalized_at) }}</span>
                                    </div>
                                </div>
                            </template><!-- .row -->
                        </div><!-- .col-12 -->
                        <div class="col-12">
                            <button @click="isCompletedSessionsExpanded = !isCompletedSessionsExpanded" class="btn bg-orange text-white float-right" data-toggle="collapse" data-target=".session-collapse-wrapper" aria-expanded="false" aria-controls="session-collapse-wrapper">{{ expandButtonText }}</button>
                        </div>
                    </div>
                </div>
            </template>
        </dashboard-tabs>
    </div>
</template>

<script>
    import ModuleIcon from '../ModuleIcon';
    import DashboardTabs from '../dashboard_tabs/DashboardTabs';
    import moment from 'moment';
    import HeelstreamVideoEmbed from './HeelstreamVideoEmbed';
    // import TrainingVideoEmbed from './TrainingVideoEmbed';
    // import ProviderTrainingKnowledgeQuiz from './ProviderTrainingKnowledgeQuiz';
    // import ProviderTrainingEvaluation from './ProviderTrainingEvaluation';
    import ProviderTrainingCertificatePrint from './ProviderTrainingCertificatePrint';
    import TrainingStartMenu from './TrainingStartMenu';
    import { mapState, mapMutations, mapGetters } from 'vuex';
    import Auth from '../../auth.js';
    import HowToRow from '../../components/HowToRow';
    import PrintDropdown from '../PrintDropdown.vue';
    import ModuleLoadingIconVue from './moduleLoadingIcon.vue'


    export default{
        components: {
            ModuleIcon,
            DashboardTabs,
            moment,
            // TrainingVideoEmbed,
            // 'provider-training-knowledge-quiz': ProviderTrainingKnowledgeQuiz,
            // 'provider-training-evaluation': ProviderTrainingEvaluation,
            // 'provider-training-certificate-print': ProviderTrainingCertificatePrint,
            'training-start-menu': TrainingStartMenu,
            'module-loading-icon':ModuleLoadingIconVue,
            HowToRow,
            PrintDropdown,

            // SurveyPage,
        },
        props: {
            modules: {
                required: true,
                type: Array
            },
            isDev: {
                type: Boolean,
                default: false
            },
            activeModules: {
                type: Array,
                default: null
            },
            programId: {
                required: false,
                type: Number,
                default: null,
            },
        },
        data() {
            return {
                // currentComponent: null,
                currentTrainingId: null,
                currentSessionId: null,
                isCompletedSessionsExpanded: false,
                isLoadingData:true,
                phoneNum: "",
            }
        },
        methods: {
            completedSessionsInModule(_module) {
                if(this.completedTrainingSessionsSorted) {
                    return this.completedTrainingSessionsSorted.filter((s, i) => {
                        if(s.module) {
                            return s.module.id == _module.id;
                        }
                    });
                }
            },
            // setCurrentContent(component, trainingId, sessionId) {
            //     this.currentSessionId = sessionId;
            //     this.currentTrainingId = trainingId;
            //     this.currentComponent = component;
            //     // this.$refs.contentModal.show();
            // },
            onContentModalHidden() {
                this.resetContent();
            },
            resetContent() {
                // this.currentComponent = null;
                this.currentSessionId = null;
                this.currentTrainingId = null;
            },
            isModuleActive(module_slug) {
                if(this.activeModules) {
                    return this.activeModules.includes(module_slug);
                }
                return true;
            },
            initState() {
                let vm = this;
                this.isLoadingData = true;
                axios.get('/provider-trainings/data' + (vm.programId ? "/program/" + vm.programId : ""))
                .then(response => {
                    let trainings = response.data.trainings; 
                    vm.initTrainings({trainings});
                    
                    let trainingSessions = response.data.trainingSessions;
                    vm.initTrainingSessions({trainingSessions});

                    let sessionParticipants = response.data.sessionParticipants;
                    vm.initSessionParticipants({sessionParticipants});

                    let latestQuizResponses = response.data.latestQuizResponses;
                    vm.initLatestQuizResponses({latestQuizResponses});

                    let latestEvaluationResponses = response.data.latestEvaluationResponses;
                    vm.initLatestEvaluationResponses({latestEvaluationResponses});

                    this.$nextTick(()=>{
                            this.isLoadingData = false;
                    })
                });
            },
            onClickCompletedSession(trainingId, sessionId) {
                console.log('onClickCompletedSession');
                // this.setCurrentContentComponent('provider-training-certificate-print', trainingId, sessionId);
                this.setCurrentContent('provider-training-certificate-print', trainingId, sessionId);

            },
            truncateTitle(title, length=30) {
                if(!title) {
                    title = "Unnamed Session";
                }
                if(title.length > length) {
                    return title.substring(0,length) + "&hellip;";
                }
                return title;
            },
            hasRole(role) {
                return Auth.is(role);
            },
            formatDate: function (value) {
                if (value) {
                    return moment(String(value)).format('MM/DD/YYYY');
                }
            },
            setCurrentContent(component, trainingId, sessionId) {
                this.setCurrentContentComponent({currentContentComponent: component});
                this.setCurrentTrainingId({currentTrainingId: trainingId});
                this.setCurrentTrainingSession({currentTrainingSession: sessionId});
                this.setShowContent({showContent: true})
            },
            /**
             * Get classes that make a row collapsible
             */
             completedSessionClasses(index) {
                let useCollapseClasses = index >= 3 && !this.isCompletedSessionsExpanded;

                return {
                    'collapse': useCollapseClasses,
                    'session-collapse-wrapper': useCollapseClasses,
                };
            },
            sessionIsClickable(session) {
                return true;
            },
            getModalAttributes(session) {
                let toggle = this.sessionIsClickable(session) ? 'modal' : '';
                let target = this.sessionIsClickable(session) ? '#session-modal' : '';

                return {
                    'data-toggle': toggle,
                    'data-target': target,
                }
            },
            ...mapMutations({
                initTrainings: 'INIT_TRAININGS',
                initTrainingSessions: 'INIT_TRAINING_SESSIONS',
                initSessionParticipants: 'INIT_SESSION_PARTICIPANTS',
                initLatestQuizResponses: 'INIT_LATEST_QUIZ_RESPONSES',
                initLatestEvaluationResponses: 'INIT_LATEST_EVALUATION_RESPONSES',
                setCurrentTrainingSession: 'SET_CURRENT_TRAINING_SESSION',
                setCurrentContentComponent: 'SET_CURRENT_CONTENT_COMPONENT',
                setCurrentTrainingId: 'SET_CURRENT_TRAINING_ID',
                setShowContent: 'SET_SHOW_CONTENT',
            })
        },
        computed: {
            currentTraining: function() {
                if(this.currentTrainingId) {
                    return this.trainings[this.currentTrainingId];
                }
                return null;
            },
            currentSession: function() {
                if(this.currentSessionId) {
                    return this.trainingSessions[this.currentSessionId];
                }
                return null;
            },
            expandButtonText: function() {
                return this.isCompletedSessionsExpanded ? "Collapse" : "Show All";
            },
            trainingTitle: function() {
                if(this.currentTraining) {
                    return this.currentTraining.title;
                }
                return "Current Training";
            },
            moduleColor() {
                if(this.currentTraining && this.currentTraining.section && this.currentTraining.section.module) {
                   return this.currentTraining.section.module.color;
                }
                return "white";
            },
            completedTrainingSessions() {
                return Object.values(this.trainingSessions).filter((s,i) => {
                    return s.is_finalized;
                });
            },
            completedTrainingSessionsSorted() {
                return this.completedTrainingSessions.sort((a, b) => {
                    // sort oldest to newest
                    return (new Date(a.finalized_at)) - (new Date(b.finalized_at));
                }).reverse(); // sort newest to oldest
            },
            currentComponent: function() {
                return this.currentContentComponent;
            },

            ...mapState([
                'trainings',
                'trainingSessions',
                'sessionParticipants',
                'currentContentComponent'
            ]),
            ...mapGetters([
                'trainingsInModule'
            ]),
        },
        mounted: function() {
            this.initState();
        }
    }
</script>
